package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository

class AddAppointmentUseCase(
    private val repository: AppointmentRepository
) {
    suspend operator fun invoke(appointment: Appointment): Result<Unit> {
        if (appointment.clientName.isBlank() || appointment.serviceName.isBlank()) {
            return Result.failure(IllegalArgumentException("Nome do cliente e serviço são obrigatórios."))
        }
        return repository.addAppointment(appointment)
    }
}
